import structuredClone from "@ungap/structured-clone";

export default defineNuxtPlugin({
  name: "polyfills",
  parallel: true,
  setup(app) {
    if (!("structuredClone" in globalThis)) {
      //@ts-ignore
      globalThis.structuredClone = structuredClone;
    }
  },
});
